import { CloseIcon } from 'components/icons/CloseIcon';
import { PaperFileIcon } from 'components/icons/PaperFileIcon';
import { WorldEarthIcon } from 'components/icons/WorldEarthIcon';
import moment from 'moment';
import api from 'services/api';

interface IRemoveResource {
  onCancel: () => void;
  currentResource?: any;
  resourceData: any[];
  setResourceData: any;
}

export default function RemoveResource({ currentResource, resourceData, setResourceData, onCancel }: IRemoveResource) {
  const removeResource = () => {
    api.delete(`api/videos/resource/${currentResource.hash_id}`).then(() => {
      const newResourceList = resourceData.filter((person: any) => {
        return person.hash_id !== currentResource.hash_id;
      });
      setResourceData(newResourceList);
      onCancel();
    });
  };

  return (
    <div className="transparent font-lato">
      <div className="relative border-x border-t bg-gray-bg-dark border-gray-300  bg-white pb-7 pt-9 px-7 w-screen md:w-[520px] md:min-h-[100px] rounded-t-lg">
        <div className="flex mb-5">
          <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">Remove resource</span>
          <CloseIcon className="ml-auto w-5 h-5 cursor-pointer opacity-70 hover:opacity-100" onClick={onCancel} />
        </div>
        <p>Are you sure you want to remove this resource?</p>
        <div className="flex items-center rounded-lg bg-white group my-5" key={currentResource.hash_id}>
          {currentResource.resource_type === 'file' && <PaperFileIcon />}
          {currentResource.resource_type === 'link' && <WorldEarthIcon />}
          <div className="ml-4">
            <p className="text-black font-bold">{currentResource.title}</p>
            <p className="text-green-main text-sm">
              Added by {currentResource.added_by.name} on{' '}
              {moment(new Date(currentResource.date_added)).format('MMM DD, YYYY')}
            </p>
          </div>
        </div>
      </div>
      <div className="flex text-[13px] pb-6 px-4 bg-white rounded-b-lg border-x">
        <button
          className="py-3 px-8 text-black border border-tabBorder ml-auto rounded-[10px] hover:bg-gray-100"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button className="bg-red-main py-3 px-8 text-white ml-2 rounded-[10px]" onClick={removeResource}>
          Remove
        </button>
      </div>
    </div>
  );
}
